import React from 'react';

/**
 * DestinationCard - Individual destination card component
 */
const DestinationCard = ({ destination, displayPrice, onClick }) => {
  const isTypical = destination.discount === 'Typical price';

  return (
    <div className="travel-card" onClick={onClick}>
      <div className="card-image-wrapper">
        <div className={`card-badge ${isTypical ? 'typical' : ''}`}>
          <i className={`fas ${isTypical ? 'fa-circle' : 'fa-check-circle'}`}></i>
          {destination.discount}
        </div>
        <img 
          src={destination.image} 
          alt={destination.city} 
          className="card-img"
          loading="lazy"
        />
      </div>
      <div className="card-content">
        <div className="card-header">
          <span className="card-title">{destination.city}, {destination.country}</span>
        </div>
        <span className="card-dates">{destination.dates}</span>
        <div className="pricing-row">
          <div className="price-item">
            <span className="price-label">
              <i className="fas fa-plane"></i> Flight
            </span>
            <span className="price-value">
              SGD {displayPrice}<span>/pp</span>
            </span>
          </div>
          <div className="price-item">
            <span className="price-label">
              <i className="fas fa-bed"></i> Hotel
            </span>
            <span className="price-value">
              SGD {destination.hotelPrice}<span>/pp</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationCard;
